import store from '../store'

function getCaseGroupName(id) {
  var theCase = store.getters.getCaseGroups.find((obj) => obj.id == id);
  if (theCase) {
    return theCase.name
  } else {
    return null
  }
}

function getCaseGroupId(name) {
  var theCase = store.getters.getCaseGroups.find((obj) => obj.name == name);
  if (theCase) {
    return theCase.id
  } else {
    return null
  }
}

function getCaseGroup(id) {
  var theCase = store.getters.getCaseGroups.find((obj) => obj.id == id);
  if (theCase) {
    return theCase
  } else {
    return null
  }
}

function getCaseGroupVatEnabled(id) {
  var theCase = store.getters.getCaseGroups.find((obj) => obj.id == id);
  if (theCase) {
    return theCase.vatValidationEnabled
  } else {
    return false
  }
}

function getCaseGroupTinEnabled(id) {
  var theCase = store.getters.getCaseGroups.find((obj) => obj.id == id);
  if (theCase) {
    return theCase.tinValidationEnabled
  } else {
    return false
  }
}

export { getCaseGroupName, getCaseGroupId, getCaseGroup, getCaseGroupVatEnabled, getCaseGroupTinEnabled }